// extracted by mini-css-extract-plugin
export default {"root":"style_root__eJKcs","breadcrumb":"style_breadcrumb__bcWOD","action":"style_action__vkYHI"};